export interface Column {
  id: "name" | "label" | "base_color" | "kpi_label";
  label: string;
  minWidth?: number;
  align?: "left" | "center" | "right";
  format?: (value: number) => string;
}

export const columns: readonly Column[] = [
  { id: "name", label: "name", minWidth: 150, align: "center" },
  { id: "label", label: "label", minWidth: 150, align: "center" },
  {
    id: "kpi_label",
    label: "kpi_label",
    minWidth: 70,
    align: "center",
    format: (value: number) => value.toLocaleString("es-ES")
  },
  {
    id: "base_color",
    label: "base_color",
    minWidth: 25,
    align: "center",
    format: (value: number) => value.toLocaleString("es-ES")
  }
];
